import { useContext } from "react";
import { CurrencyContext } from "../../contexts/currencyContext";

export function useCurrencyContext() {
  const values = useContext(CurrencyContext);
  return values;
}
